import {translate} from 'views/module';

import moment from 'moment';

const MISSING_TRANSLATION = 'Missing translation';

export const formatDateTime = (value) => {
  return value ? moment(value).format(translate('timeFormat.ShortMonthDayTime')) : '-';
};

export const formatDate = (value) => {
  return value ? moment(value).format(translate('timeFormat.ShortMonthDayYear')) : '-';
};

// Loom enums grow without a WebsiteAdmin release, so a value with no string falls back to text
// the caller chooses rather than "Missing translation".
export const translateOr = (expression, fallback) => {
  const translated = translate(expression);
  return translated === MISSING_TRANSLATION ? fallback : translated;
};

export const personName = (person) => {
  return [person?.firstName, person?.lastName].filter(Boolean).join(' ');
};
